import React, {useEffect, useState} from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';

import { withRouter } from "react-router";

import { useFormik } from 'formik';

import {PersistGuestAccountService} from '../../../services/auth.service';
import { useAuth } from "../../../context/auth";
import {toastWarning} from "../../../utils/utils";
import LoaderWithBackDrop from "../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";
import {LOCAL_STORAGE_KEYS} from "../../../utils/constants";
import {Redirect} from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent:'center',
        minHeight: '82vh',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",
        color: '#fff',
        '&:hover': {
            background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",
        },
        margin: theme.spacing(3, 0, 2),
    },
    footer: {
        marginTop: 'auto',
        textAlign: 'center',
        width:'full-width',
    },
}));

const PersistGuestAccount = (props) => {
    const classes = useStyles();
    const [loading, setLoading] = useState(false);
        const referer = props.location.referer || '/home';

    const { setAuthToken, setAuthUser, authUser } = useAuth();

    useEffect(() => {
        if (!authUser.is_guest) {
            props.history.push('/home')
        }
    }, []);

    const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
            confirm_password: '',
            remember_me: false
        },
        onSubmit: async (values) => {
            // console.log('Auth User => ', authUser)
            if (values.password !== values.confirm_password) {
                return toastWarning('Please provide the same password in both password fields!')
            }

            try {
                setLoading(true);
                const result = await PersistGuestAccountService(values.email, values.password);

                if (result.data && result.data.user) {
                    await setAuthUser(result.data.user);
                    //clear the guest-fingerprint from local-storage
                    localStorage.removeItem(LOCAL_STORAGE_KEYS.guest_fingerprint);
                }
                setLoading(false);
            } catch (e) {
                // already toasted the error
                setLoading(false);
            }

            return <Redirect to={referer} />;
        }
    });

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline/>
            <div className={classes.paper}>
                {/*<Avatar className={classes.avatar}>*/}
                {/*    <LockOutlinedIcon/>*/}
                {/*</Avatar>*/}
                <Typography component="h1" variant="h3" style={{
                    background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
                    color: 'transparent',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    fontWeight: 'semibold',
                }}>
                    Sign Up
                </Typography>
                <form className={classes.form} noValidate onSubmit={formik.handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                style={{backgroundColor:'#fff'}}
                                variant="outlined"
                                required
                                fullWidth
                                id="email"
                                label="Email Address"
                                name="email"
                                autoComplete="email"
                                onChange={formik.handleChange}
                                value={formik.values.email}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                style={{backgroundColor:'#fff'}}
                                variant="outlined"
                                required
                                fullWidth
                                name="password"
                                label="Password"
                                type="password"
                                id="password"
                                autoComplete="current-password"
                                onChange={formik.handleChange}
                                value={formik.values.password}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                style={{backgroundColor:'#fff'}}
                                variant="outlined"
                                required
                                fullWidth
                                name="confirm_password"
                                label="Confirm Password"
                                type="password"
                                id="confirm_password"
                                autoComplete="current-password"
                                onChange={formik.handleChange}
                                value={formik.values.confirm_password}
                            />
                        </Grid>

                        {/*{*/}
                        {/*    !authUser.company_info_exist && (*/}
                        {/*        <p>Company Information needs to be collected here</p>*/}
                        {/*    )*/}
                        {/*}*/}
                    </Grid>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                    >
                        Sign Up
                    </Button>
                </form>
            </div>
            <LoaderWithBackDrop loading={loading}/>
        </Container>
    );
}

export default withRouter(PersistGuestAccount);